import React, { Component } from 'react';
import { StyledHeader } from '../styles';
import ParnerLogo from '../../Content/Shared/PartnerLogo';

class EidsivaHeader extends Component {
  render() {
    return (
      <StyledHeader background="#e1124d" boxShadow="none">
        <ParnerLogo
          getTranslation={(messageCode) => this.props.getTranslation(messageCode)}
          isHeaderLogo={true}
        />
      </StyledHeader>
    );
  }
}

export default EidsivaHeader;
